import { INTENT_TYPE } from '../../constants';
import { resolveCueFamily } from '../features/cue-family';
import { splitOnSeparator, stripLeadingPhrase } from '../features/cues';
import { hasOperandEvidence } from '../features/operand-evidence';
import {
	COMPARE_SEPARATORS,
	REQUEST_PREFIXES,
	TRANSFORM_COMPARE_CUE,
	TRANSFORM_SINGLE_OPERAND_CUES,
} from '../pack/lexicons';
import { type ConvergenceRule, type FeatureContext } from '../types';

/**
 * `C-TRANSFORM` (priority 945) — do something to content the user names.
 *
 * Two arities, because they need different evidence:
 *
 * - `summarize`, `rewrite`, `extract`, `draft`, `translate` take one complete operand.
 * - `compare` takes two, separated by exactly `and`, `with`, `vs`, or `versus` **outside**
 *   protected ranges — so `compare "a and b" with c` splits on `with`, not on the `and`
 *   inside the quoted title.
 */
const matchesCompare = (features: FeatureContext): boolean => {
	const qMatch = features.qMatch;
	const prefix = stripLeadingPhrase(qMatch, REQUEST_PREFIXES);
	const cue = stripLeadingPhrase(prefix ? prefix.rest : qMatch, [TRANSFORM_COMPARE_CUE]);

	if (!cue) {
		return false;
	}

	const split = splitOnSeparator(cue.rest, COMPARE_SEPARATORS);

	return split !== null && hasOperandEvidence(split.left) && hasOperandEvidence(split.right);
};

export const matchesTransform = (features: FeatureContext): boolean =>
	resolveCueFamily(features, { cues: TRANSFORM_SINGLE_OPERAND_CUES }) !== null ||
	matchesCompare(features);

export const transformRule: ConvergenceRule = {
	type: INTENT_TYPE.CHAT,
	pattern: 'TRANSFORM',
	matches: matchesTransform,
};
